import { Grid } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Rating from "@material-ui/lab/Rating";
import { useState } from "react";

export default function RateArticle(prop: any) {
  const { reviewId, rating, postRating } = prop;

  const [hover, setHover] = useState(-1);
  const labels: { [index: string]: string } = {
    1: "Rewiew was rudimentary and largly unhelpful ",
    2: "Rewiew was partial, limited in its scope or detail ",
    3: "Rewies was sufficient to contribute to th editorial decision ",
    4: "Rewiew was generally very good and made some telling paints ",
    5: "Rewiew was excellent, being thorough, detailed and insightful ",
  };

  return (
    <Grid container spacing={3} alignItems="center">
      <Grid item>
        <b>Quality Assessment</b>
      </Grid>
      <Grid item xs={2} sm={2} spacing={3}>
        <Rating
          name={reviewId}
          value={rating}
          size="large"
          onChange={(event: any, newValue: any) => {
            postRating(event.target.name, newValue);
          }}
          onChangeActive={(event: any, newHover: any) => {
            setHover(newHover);
          }}
        />
      </Grid>
      <Grid item xs={4} sm={4} spacing={3}>
        {<Box ml={2}>{labels[hover !== -1 ? hover : rating]}</Box>}
      </Grid>
      <Grid item xs={6} sm={6} spacing={3}></Grid>
    </Grid>
  );
}
